

























import { defineComponent } from "@vue/composition-api";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "GroupSelectedInformer",
  components: { BaseIcon },
  props: {
    selectedGroupCount: { type: Number, default: 0 },
    excludedGroupCount: { type: Number, default: 0 },
    recipientCount: { type: Number, default: 0 },
  },
});
